import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Modal } from 'antd';
import '../../../index.scss';
import { customBaseUrl, httpPut } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';

const UpdateCardType = ({ showModal, hideModal, getCardTypes, initialData }) => {
  const [data, setData] = useState(() => {
    if (initialData) {
      return {
        type: initialData.type || '',
        id: initialData.id || '',
        active: initialData.active ?? true
      };
    }
    return { type: '', id: '', active: true };
  });

  useEffect(() => {
    if (initialData) {
      setData({
        type: initialData.type || '',
        id: initialData.id || '',
        active: initialData.active ?? true
      });
    }
  }, [initialData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.type) {
      Swal.fire('Warning', 'Card Type is required', 'warning');
      return;
    }
    showLoader();
    const { id, type, active } = data;
    
    // 1. Update card type details using standard path and parameters
    let res = await httpPut(
      `${customBaseUrl.cardUrl}/cms/admin/update-card-type/${id}?cardTypeId=${id}&type=${type}&cardType=${type}`,
      { id, type, active }
    );

    // 2. Call activation/deactivation endpoint if status changed
    if (initialData && initialData.active !== active) {
      const statusUrl = active
        ? `${customBaseUrl.cardUrl}/cms/admin/activate-card-type/${id}`
        : `${customBaseUrl.cardUrl}/cms/admin/deactivate-card-type/${id}`;
      await httpPut(statusUrl);
    }

    const isSuccess = res && (
      res.status === true || 
      res.respCode === 0 || 
      (res.message && (
        res.message.toLowerCase().includes('success') || 
        res.message.toLowerCase().includes('activated') || 
        res.message.toLowerCase().includes('deactivated') ||
        res.message.toLowerCase().includes('updated')
      ))
    );

    if (isSuccess) {
      hideLoader();
      Swal.fire('Done', 'Card type updated successfully', 'success');
      hideModal(false);
      getCardTypes();
    } else {
      hideLoader();
      Swal.fire('Error', res?.message || 'Failed to update card type', 'error');
    }
  };

  return (
    <Modal
      title={<span style={{ fontSize: '18px', fontWeight: 700, color: '#1C1C1C' }}>Update Card Type</span>}
      centered
      visible={showModal}
      open={showModal}
      onOk={() => hideModal(false)}
      onCancel={() => hideModal(false)}
      width={550}
      footer={null}
      bodyStyle={{ padding: '24px' }}
    >
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#344054' }} htmlFor='cardTypeInput'>
              Type
            </label>
            <input
              type='text'
              className='form-control'
              id='cardTypeInput'
              required
              value={data.type}
              onChange={(e) => setData({ ...data, type: e.target.value })}
              style={{
                width: '100%',
                padding: '10px 14px',
                borderRadius: '8px',
                border: '1px solid #D0D5DD',
                fontSize: '14px',
                outline: 'none',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                transition: 'border-color 0.2s'
              }}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '4px' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#344054', marginBottom: 0 }} htmlFor='activeSwitchType'>
              Active Status
            </label>
            <div className='form-check form-switch mb-0'>
              <input
                className='form-check-input'
                type='checkbox'
                id='activeSwitchType'
                style={{ width: '40px', height: '20px', cursor: 'pointer', margin: 0 }}
                checked={data.active}
                onChange={(e) => setData({ ...data, active: e.target.checked })}
              />
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '12px' }}>
            <button
              type='submit'
              style={{
                background: '#FF4B01',
                color: '#fff',
                border: 'none',
                padding: '12px 32px',
                fontSize: '15px',
                fontWeight: 600,
                borderRadius: '8px',
                cursor: 'pointer',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                width: '100%',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.background = '#E04200'}
              onMouseLeave={(e) => e.target.style.background = '#FF4B01'}
            >
              Update Type
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default UpdateCardType;
